// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"538":"69e891000dc139a2","666":"5aeb3a5a01b71b87","719":"9bb812354010d2b9"}[chunkId] + ".js";
};